import { useRouteQuery } from '@/common/route/useRouteQuery';
import { pageSize } from '@/common/utils/helpers';
import { useBaseListView } from '@/common/view/useBaseListView';
import { useCrudActions } from '@/common/view/useCrudActions';
import { avatarService } from '@/services/avatar';
import useVuelidate from '@vuelidate/core';
import { minLength } from '@vuelidate/validators';

export function useAvatarCategorytList() {
    const { query, updateQueryToRoute } = useRouteQuery({
        definition: {
            name: { type: 'string', default: '' },
            parentId: { type: 'number', default: null },
            offset: { type: 'number', default: 0 },
            limit: { type: 'number', default: pageSize }
        },
        onChange: () => fetchList()
    });

    const validations = {
        name: { min: minLength(3) }
    };

    const v$ = useVuelidate(validations, query);

    const { list, total, fetchList } = useBaseListView({
        request: avatarService.category.list,
        paramsBuilder: () => ({ ...query }),
        hooks: {
            onPageChange: offset => (query.offset = offset),
            onSuccess: updateQueryToRoute,
            canFetch: () => {
                v$.value.$touch();
                return !v$.value.$invalid;
            }
        }
    });

    const actions = {
        remove: useCrudActions().confirmAndRemove({
            request: avatarService.category.remove,
            onSuccess: () => fetchList()
        })
    };

    return { query, v$, list, total, fetchList, actions };
}
